import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgId = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "outline-flat",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 64 64",
	"aria-hidden": "true",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .cls-1 {\n        fill: currentColor;\n        stroke-width: 0px;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M63.5,57.5H.5V6.5h63v51ZM3.5,54.5h57V9.5H3.5v45Z"
		}),
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("rect", {
				className: "cls-1",
				x: 38.99,
				y: 31.91,
				width: 17,
				height: 3
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "cls-1",
				x: 38.99,
				y: 41.91,
				width: 17,
				height: 3
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M22.49,36.91c-3.03,0-5.5-2.47-5.5-5.5s2.47-5.5,5.5-5.5,5.5,2.47,5.5,5.5-2.47,5.5-5.5,5.5ZM22.49,28.91c-1.38,0-2.5,1.12-2.5,2.5s1.12,2.5,2.5,2.5,2.5-1.12,2.5-2.5-1.12-2.5-2.5-2.5Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M33.99,49.91H10.99v-1.5c0-5.24,4.26-9.5,9.5-9.5h4c5.24,0,9.5,4.26,9.5,9.5v1.5ZM14.16,46.91h16.65c-.68-2.86-3.26-5-6.33-5h-4c-3.07,0-5.65,2.14-6.33,5Z"
			})
		] }), /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("rect", {
			className: "cls-1",
			x: 47.01,
			y: 16.9,
			width: 9,
			height: 3
		}), /* @__PURE__ */ _jsx("rect", {
			className: "cls-1",
			x: 50.01,
			y: 13.9,
			width: 3,
			height: 9
		})] })] })
	]
});
export default SvgId;
